module.exports = __webpack_public_path__ + "img/online_services.1f63f08b.svg";